import type { Match } from '@uefadigital/panenka';

import type { ConfigCompetition } from 'utils/config';
import config from 'utils/config';

export const getPlayerLink = (playerId: string | undefined, competition: ConfigCompetition) => {
  const siteUrl = 'https://www.uefa.com';

  if (competition.type === 'club') {
    return `${siteUrl}/${competition.name}/clubs/players/${playerId}`;
  }

  return `${siteUrl}/${competition.name}/teams/players/${playerId}`;
};

export const handleGoToLink = (link: string | undefined) => {
  link && window.open(link);
};

export const isFemale = (competitionId: string | undefined) => {
  return config.competitions.find((item) => item.id === competitionId)?.sex === 'FEMALE';
};

export const isMatchValid = (match: Match) => {
  const competition =
    config.competitions.find((item) => item.id === match.competition.id) || config.competitionsDefault;
  const seasonYear = match.seasonYear ?? new Date().getFullYear();

  const isCompetitionMatch = match.competition.id === competition.id;

  if (competition.type !== 'national') {
    const isSeasonMatch = match?.matchday?.seasonYear === seasonYear;

    return isCompetitionMatch && isSeasonMatch;
  }

  return isCompetitionMatch;
};
